import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OtpValidatedGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const isValidated = sessionStorage.getItem('validated') && sessionStorage.getItem('validated') === 'true';
    if (!isValidated){
      this.router.navigate(['/mobile-validation']);
    }
    return isValidated;
  }
}
